export default "__VITE_ASSET__f09ccf0b__"